import styled from 'styled-components';

const ProductBadgesStyle = styled.div`
	position: absolute;
	top: var(--sp2x);
	left: var(--sp2x);
	display: flex;
	flex-wrap: wrap;
	gap: var(--sp1x);
	max-width: 50%;
	z-index: 2;

	.badge {
		display: inline-block;
		padding: var(--sp1x) var(--sp1-5x);
		border-radius: var(--sp2-5x);
		white-space: nowrap;
		font-size: var(--h6);
		text-transform: capitalize;
		line-height: 1;
		font-weight: 500;
		color: var(--purple);

		&.LightGreen {
			background: #e7f5f2;
		}
		&.Pink {
			background: #fed1d0;
		}
		&.Lavender {
			background: #eadcf8;
		}
		&.LightBlue {
			background: #deeaff;
		}
		&.LightPink {
			background: #ffe6fd;
		}
		&.Outofstock {
			border: 1px solid var(--green);
			background: var(--white);
		}
	}
`;

export default ProductBadgesStyle;
